'use strict';

$(document).ready(function () {
    const groupedIndex = document.querySelector('.js-grouped-index');

    if (groupedIndex) {
        const header = document.querySelector('header');
        const letterIndex = groupedIndex.querySelector('.js-letter-group');
        const groups = groupedIndex.querySelectorAll('.js-letter-list-group');

        if (!header || !letterIndex || !groups) {
            return;
        }

        const adjustLetterIndexStickyTop = () => {
            const headerBottom = header.getClientRects()[0].bottom;

            if (headerBottom > 0) {
                letterIndex.style.top = `${headerBottom}px`;
            } else {
                letterIndex.style.top = '0';
            }
        };

        const activateCurrentLetter = () => {
            const scrollOffset = window.scrollY;
            const letterIndexBottom = letterIndex.getClientRects()[0].bottom;
            const activeGroupOffset = scrollOffset + letterIndexBottom + 1;

            groups.forEach((group) => {
                const groupTop = group.offsetTop;
                const groupBottom = groupTop + group.clientHeight;

                if (activeGroupOffset >= groupTop && activeGroupOffset < groupBottom) {
                    const groupLetter = group.getAttribute('data-group-letter');

                    groupedIndex.querySelectorAll('.js-letter-group-item').forEach((letter) => {
                        if (letter.classList.contains(`js-grouped-index-letter-${groupLetter}`)) {
                            letter.classList.add('active');
                        } else {
                            letter.classList.remove('active');
                        }
                    });
                }
            });
        };

        window.addEventListener('scroll', () => {
            adjustLetterIndexStickyTop();
            activateCurrentLetter();
        });

        window.addEventListener('resize', () => {
            adjustLetterIndexStickyTop();
            activateCurrentLetter();
        });

        activateCurrentLetter();

        const letterItems = letterIndex.querySelectorAll('.js-letter-group-item');

        var enterGroup = function (group) {
            var links = group.querySelectorAll('a');
            links.forEach(function (link) {
                link.setAttribute('tabindex', '0');
            });
            if (links.length) {
                links[0].focus();
            }
        };

        var leaveGroup = function (group) {
            group.querySelectorAll('a').forEach(function (link) {
                link.setAttribute('tabindex', '-1');
            });
        };

        // Scroll to group on click (existing behavior)
        letterIndex.querySelectorAll('[data-scroll-to-target]').forEach((button) => {
            button.addEventListener('click', (event) => {
                const groupSelector = event.target.closest('[data-scroll-to-target]')?.getAttribute('data-scroll-to-target');

                if (!groupSelector) {
                    return;
                }

                const group = groupedIndex.querySelector(groupSelector);
                const offset = group.offsetTop - header.clientHeight - letterIndex.clientHeight;

                window.scroll({
                    top: offset,
                    left: 0,
                    behavior: 'smooth'
                });
            });
        });

        // Keyboard navigation for letter toolbar (Arrow keys between letters, Enter/Space to enter group)
        letterIndex.addEventListener('keydown', (e) => {
            var item = e.target.closest('.js-letter-group-item');
            if (!item) {
                return;
            }

            var items = Array.from(letterItems);
            var idx = items.indexOf(item);

            if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') {
                e.preventDefault();
                var next = e.key === 'ArrowRight' ? items[idx + 1] || items[0] : items[idx - 1] || items[items.length - 1];
                item.setAttribute('tabindex', '-1');
                next.setAttribute('tabindex', '0');
                next.focus();
            }

            if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                item.click();
                var targetSelector = item.getAttribute('data-scroll-to-target');
                var group = targetSelector && groupedIndex.querySelector(targetSelector);
                if (group) {
                    // Deactivate any previously active group
                    groups.forEach(leaveGroup);
                    setTimeout(function () {
                        enterGroup(group);
                    }, 350);
                }
            }
        });

        // Escape from brand group returns focus to the corresponding letter
        groups.forEach((group) => {
            group.addEventListener('keydown', (e) => {
                if (e.key !== 'Escape') {
                    return;
                }
                var letter = group.getAttribute('data-group-letter');
                var letterItem = groupedIndex.querySelector('.js-grouped-index-letter-' + letter);
                leaveGroup(group);
                if (letterItem) {
                    letterItem.focus();
                }
            });
        });
    }
});
